import contentfulGql from 'js/lib/contentfulGql';

const AuthoredArticleFieldsFragment = contentfulGql`#graphql
  fragment AuthoredArticleFields on Article {
    slug
    title
    intro
    localizedCountryCode
    featuredImage {
      description
      url(transform: {
        width: 330,
        height: 216,
        resizeStrategy: FILL,
        resizeFocus: FACES,
        format: JPG_PROGRESSIVE,
        quality: 60
      })
    }
    sys {
      firstPublishedAt
      publishedAt
    }
  }
`;

export const articlesAuthor = contentfulGql`#graphql
  ${AuthoredArticleFieldsFragment}
  query articlesAuthorPage($slug: String!, $preview: Boolean!, $limit: Int!, $skip: Int!){
    articlesAuthorCollection(limit: 1, preview: $preview, where: { slug: $slug }) {
      items {
        sys {
          id
        }
        name
        slug
        description
        jobTitle
        externalWebsites
        image {
          url(transform: {
            width: 400,
            height: 400,
            resizeStrategy: FILL,
            resizeFocus: FACES,
            format: JPG_PROGRESSIVE,
            quality: 60
          })
        }
        knowsAboutCollection {
          items {
            title
            slug
            languageCode
            countryCode
          }
        }
      }
    }
    articleCollection(where: { authors: {slug:  $slug} }, limit: $limit, skip: $skip, preview: $preview, order: sys_firstPublishedAt_DESC) {
      total
      items {
        ...AuthoredArticleFields
      }
    }
  }`;
